import { render, staticRenderFns } from "./PaymentPlans.vue?vue&type=template&id=3c2e6d28&scoped=true&"
import script from "./PaymentPlans.vue?vue&type=script&lang=js&"
export * from "./PaymentPlans.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPlans.vue?vue&type=style&index=0&id=3c2e6d28&lang=scss&scoped=true&"
import style1 from "./PaymentPlans.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e6d28",
  null
  
)

/* custom blocks */
import block0 from "./PaymentPlans.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./PaymentPlans.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
